module.exports = __webpack_public_path__ + "img/政策法规.16060a85.jpg";